import type {
  DocumentData,
  DocumentSnapshot,
  QueryDocumentSnapshot,
  QuerySnapshot,
} from 'firebase/firestore';

export const readQueryDocument = <T>(
  doc: QueryDocumentSnapshot<DocumentData>,
): T => {
  return doc.data() as unknown as T;
};

export const readDocumentSnapshot = <T>(
  snapshot: DocumentSnapshot<DocumentData>,
): T | undefined => {
  return snapshot.exists() ? (snapshot.data() as unknown as T) : undefined;
};

export const readQuerySnapshot = <T>(
  snapshot: QuerySnapshot<DocumentData>,
): T[] => {
  return snapshot.docs.map((doc) => readQueryDocument<T>(doc));
};
